import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const TextArea = styled.textarea`
  background-color: rgb(255, 255, 255, 1);
  border: 1px solid #cccccc;
  border-radius: 0;
  color: rgba(0, 0, 0, 1);
  font-weight: normal;
  font-size: 18px;
  height: 120px;
  outline: 0;
  padding: 8px;
  width: 100%;
  &:focus {
    outline: 1px solid #64b5f6;
  }
`;

export default function SentiTextarea(props) {
  const { handleChange, name, placeholder, textareaId } = props;

  return (
    <TextArea
      data-testid="senti-textarea"
      id={textareaId}
      name={name}
      onChange={handleChange}
      placeholder={placeholder}
    />
  );
}

SentiTextarea.propTypes = {
  handleChange: PropTypes.func.isRequired,
  placeholderText: PropTypes.string,
  name: PropTypes.string,
  textareaId: PropTypes.string,
};

SentiTextarea.defaultProps = {
  labeltext: null,
  handleChange: () => {},
  name: "textarea",
  placeholder: "Type your text here.",
  textareaId: "textarea",
};
